export default "<h1>Group list</h1>\n<xodos-group-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></xodos-group-table>\n";